'use client';

import { BookOpen, ListDashes } from '@phosphor-icons/react';
import { CodeBlock } from '@phosphor-icons/react/dist/ssr';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@skrym/shared/ui/sidebar';

import { pagesMetadata } from '@/.velite';

interface SidebarNavigationProps extends React.ComponentProps<typeof SidebarGroup> {
  showApiReference: boolean;
}

export function SidebarNavigation(props: SidebarNavigationProps) {
  const { showApiReference, ...rest } = props;

  const pathname = usePathname();
  const { setOpenMobile } = useSidebar();

  const isDocsActive = pagesMetadata.some((p) => p.pathname === pathname);

  return (
    <SidebarGroup {...rest}>
      <SidebarGroupContent>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild isActive={isDocsActive} onClick={() => setOpenMobile(false)}>
              <Link href="/">
                <BookOpen weight="bold" className="mr-1" /> Docs
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>

          <SidebarMenuItem>
            <SidebarMenuButton asChild isActive={pathname.startsWith('/changelog')}>
              <Link href="/changelog" onClick={() => setOpenMobile(false)}>
                <ListDashes weight="bold" className="mr-1" /> Changelog
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>

          {showApiReference && (
            <SidebarMenuItem>
              <SidebarMenuButton asChild isActive={pathname.startsWith('/api-reference')}>
                <Link href="/api-reference" onClick={() => setOpenMobile(false)}>
                  <CodeBlock weight="bold" className="mr-1" /> API Reference
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          )}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
